import React, { useState, useEffect } from 'react';
import isFunction from 'lodash/isFunction';
import UI from '../../ui';
import Utils from '../../utils';
import { LearningCenterArticleLink } from '../../learningCenter/LearningCenterArticleLink.component';

const { WrappedButton, WrappedButtonType, WrappedAccordion, WrappedAccordionTabTemplate } = UI;
const { Session, Communication, withLayoutAndModalContexts, AccountCaps, Util } = Utils;

const RefundAssistView = props => {
	const [refundAssistEnabled, setRefundAssistEnabled] = useState(false);
	const [accountCapabilities, setAccountCapabilities] = useState();
	const [userInfoRecieved, setUserInfoRecieved] = useState(false);
	const [disableUpdateButton, setdisableUpdateButton] = useState(false);

	const { refundassistRefundPercent } = Session.getAccountInfo();

	const {
		modalContext: { showError },
	} = props;

	const getUserInfo = async () => {
		const userInfo = await Communication.getUsers();

		setUserInfoRecieved(true);

		if (Communication.isSuccessful(userInfo)) {
			const {
				data: { AccountCapabilities },
			} = userInfo;

			setAccountCapabilities(AccountCapabilities);

			setRefundAssistEnabled(Util.hasBitSet(AccountCapabilities, AccountCaps.acRefundAssist));
		}
	};

	const updateAccountCapabilities = async updatedCaps => {
		const capabilitiesResponse = await Communication.updateAccountCapabilities(updatedCaps);

		if (Communication.isSuccessful(capabilitiesResponse)) {
			getUserInfo();
		} else {
			showError({ capabilitiesResponse });
		}
	};

	const updateRefundAssist = enable => {
		let updatedCaps;

		setdisableUpdateButton(true);

		if (enable) {
			updatedCaps = Util.setBit(accountCapabilities, AccountCaps.acRefundAssist);
			setdisableUpdateButton(false);
		} else {
			updatedCaps = Util.removeBit(accountCapabilities, AccountCaps.acRefundAssist);
			setdisableUpdateButton(false);
		}

		setAccountCapabilities(updatedCaps);
		updateAccountCapabilities(updatedCaps);
	};

	const onClickDone = () => {
		const { IsInWinClient } = Session.getSettings();
		const { completionCallback } = props;

		if(IsInWinClient === true) {
			window.external.Close();
		}

		if (isFunction(completionCallback)) {
			completionCallback({ close: true });
		}
	};

	useEffect(async () => {
		getUserInfo();
	}, []);

	return (
		<div className="settings-mail-refund-assist-view">
			<div className="settings-body">
				<div className="settings-content-header">
					<p>Refund Assist</p>
					<hr />
				</div>
				{userInfoRecieved &&
					(!refundAssistEnabled ? (
						<div className="p-grid p-nogutter p-dir-col refund-assist-container">
							<div className="p-col-12">
								<p className="sub-heading">
									Never miss a refund for unused USPS® shipping labels!
								</p>
								<p>
									We've analyzed your USPS labels and determined you could benefit
									from our Refund Assist feature. With Refund Assist, you
									authorize Stamps.com to identify which of your unused USPS
									labels are eligible for a refund and to submit a refund request
									on your behalf.{' '}
									<b>
										We'll credit {refundassistRefundPercent}% of the
										USPS-approved refund amount to your account balance.
									</b>
								</p>
							</div>
							<div className="p-col-12 refund-assist-footer">
								<WrappedButton
									className="refund-enable-button"
									label="Enable now"
									type="button"
									disabled={disableUpdateButton}
									onClick={() => {
										updateRefundAssist(true);
									}}
									dataqa="refund-assist-enable-now"
								/>
								<LearningCenterArticleLink
									linkText="Learn more"
									stamps="27608643172635"
									endicia="27735639449627"
								/>
							</div>
						</div>
					) : (
						<div className="p-grid p-dir-col refund-assist-disable">
							<div className="p-col-12">
								<p>
									<b>
										You have authorized Stamps.com to review unused, trackable
										USPS® labels, to identify which labels are eligible for a
										refund, and to submit refund requests to USPS on your
										behalf.
									</b>
								</p>
								<p>
									The review includes USPS labels that have not entered the mail
									stream within 21 days of the label print date. You can view
									eligible labels on the History page at any time. Once we
									schedule labels for a refund request, you have five days to
									exclude any labels you do not want refunded through Refund
									Assist.
								</p>
								<p>
									Stamps.com will then submit the refund request for the eligible
									labels to USPS on your behalf. USPS reviews the request within
									about 1-4 weeks. You'll then receive a credit to your account
									balance for {refundassistRefundPercent}% of the USPS-approved
									refund amount.
								</p>
								<p>
									To view the credited amount for any specific label, go to the
									History page and open the label details for any label refunded
									with Refund Assist.
								</p>
								<LearningCenterArticleLink
									linkText="Learn more about Refund Assist"
									stamps="27608643172635"
									endicia="27735639449627"
								/>
								<div className="disclaimer">
									<p>
										<b>USPS Fraud Disclaimer</b>
									</p>
									<p>
										The filing of false, fictitious, or fraudulent refund
										requests may be punishable under the criminal laws of the
										United States. 18 U.S.C. $1001.
									</p>
									<p>
										By opting into Refund Assist, you certify that the labels
										submitted for refund were unused and have been destroyed.
										You will be charged the cost of postage and a penalty for
										any refunded labels that are found to be used.
									</p>
								</div>
							</div>
							<div className="p-col-12">
								<WrappedButton
									label="Disable Refund Assist"
									buttonType={WrappedButtonType.Secondary}
									disabled={disableUpdateButton}
									onClick={() => updateRefundAssist(false)}
									dataqa="refund-assist-disable"
								/>
							</div>
						</div>
					))}
			</div>
			<div className="settings-content-footer">
				<WrappedButton
					className="settings-button"
					label="Done"
					type="button"
					onClick={onClickDone}
					dataqa="savesettings"
				/>
			</div>
		</div>
	);
};

export default withLayoutAndModalContexts(RefundAssistView);
